<template>
  <BaseModal
    id="create-customer-infoauto"
    :value="true"
    :clickOutsideClose="false"
    @input="$emit('close')"
  >
    <div class="body p-10 pt-0">
      <div class="flex justify-between items-center mb-2">
        <h1>{{ $t("create_infoauto_customer_modal.title") }}</h1>
      </div>
      <form class="flex flex-col pt-1" @submit.prevent="createCustomer">
        <label class="flex flex-row items-center gap-2 mb-1">
          <input type="checkbox" v-model="newCustomer.dropship" />
          <span class="font-semibold">{{
            $t("create_infoauto_customer_modal.dropship_only")
          }}</span>
        </label>
        <p v-if="newCustomer.dropship" class="text-sm text-gray-500 mb-2">
          {{ $t("create_infoauto_customer_modal.dropship_only_hint") }}
        </p>

        <!-- Dropship only: the name, plus seller / sale mode only when there
             is no default for them -->
        <div v-if="newCustomer.dropship" class="grid grid-cols-2 gap-2">
          <div class="input-item col-span-2">
            <label for="dropship-name">{{
              $t("create_infoauto_customer_modal.full_name")
            }}</label>
            <input
              type="text"
              class="regular bordered full"
              id="dropship-name"
              v-model="newCustomer.name"
              required
            />
          </div>
          <div class="input-item" v-if="!defaultSeller">
            <label for="dropship-seller">{{ $t("orders_page.seller") }}</label>
            <select
              required
              v-model="newCustomer.seller"
              id="dropship-seller"
              class="regular full bordered"
            >
              <option value="">{{
                $t("create_infoauto_customer_modal.select_seller")
              }}</option>
              <option
                v-for="seller in sellers"
                :key="seller.id"
                :value="seller.id"
                >{{ seller.name }}
              </option>
            </select>
          </div>
          <div class="input-item" v-if="!defaultModalidadVtaId">
            <label for="dropship-modalidad-venta">{{
              $t("order.modalidad_venta")
            }}</label>
            <select
              class="regular bordered full"
              id="dropship-modalidad-venta"
              v-model="newCustomer.modalidadVtaId"
              required
            >
              <option
                :value="modalidadVenta.modalidadVtaId"
                :key="modalidadVenta.modalidadVtaId"
                v-for="modalidadVenta of modalidadesVenta"
                >{{ modalidadVenta?.codigo || "" }}</option
              >
            </select>
          </div>
        </div>

        <div v-if="!newCustomer.dropship" class="grid grid-cols-2 gap-2">
          <div class="input-item">
            <label for="modalidad-venta">{{
              $t("order.modalidad_venta")
            }}</label>
            <select
              type="modalidad-venta"
              class="regular bordered full"
              id="modalidad-venta"
              v-model="newCustomer.modalidadVtaId"
              required
            >
              <option
                :value="modalidadVenta.modalidadVtaId"
                :key="modalidadVenta.modalidadVtaId"
                v-for="modalidadVenta of modalidadesVenta"
                >{{ modalidadVenta?.codigo || "" }}</option
              >
            </select>
          </div>
          <div class="input-item">
            <label for="company">{{
              $t("create_infoauto_customer_modal.type_of_customer")
            }}</label>
            <select
              type="company"
              class="regular bordered full"
              id="company"
              v-model="newCustomer.type"
              required
            >
              <option value="single">{{
                $t("create_infoauto_customer_modal.type_individual")
              }}</option>
              <option value="company">{{
                $t("create_infoauto_customer_modal.type_company")
              }}</option>
            </select>
          </div>
        </div>
        <hr
          class="my-2"
          v-if="!newCustomer.dropship && newCustomer.type !== ''"
        />
        <div class="grid grid-cols-2 gap-2" v-if="!newCustomer.dropship">
          <div v-if="newCustomer.type !== ''">
            <div class="input-item" v-if="newCustomer.type === 'single'">
              <label for="name">{{ $t("name") }}</label>
              <input
                type="text"
                class="regular bordered full"
                id="name"
                v-model="newCustomer.name"
                required
              />
            </div>
            <div class="input-item" v-if="newCustomer.type === 'single'">
              <label for="surname">{{
                $t("create_infoauto_customer_modal.surname")
              }}</label>
              <input
                type="text"
                class="regular bordered full"
                id="surname"
                v-model="newCustomer.surname"
                required
              />
            </div>
            <div class="input-item" v-if="newCustomer.type === 'company'">
              <label for="company-name">{{
                $t("create_infoauto_customer_modal.company_name")
              }}</label>
              <input
                type="text"
                class="regular bordered full"
                id="company-name"
                v-model="newCustomer.companyName"
              />
            </div>
            <div class="input-item">
              <label for="email">{{ $t("email") }}</label>
              <input
                type="email"
                class="regular bordered full"
                id="email"
                v-model="newCustomer.email"
                required
              />
            </div>
            <div class="input-item">
              <label for="area-code">{{
                $t("create_infoauto_customer_modal.area_code")
              }}</label>
              <input
                type="text"
                class="regular bordered full"
                id="area-code"
                v-model.trim="newCustomer.areaCode"
                :maxlength="areaCodeMaxLength"
              />
            </div>
            <div class="input-item">
              <label for="phone">{{ $t("phone") }}</label>
              <input
                type="phone"
                class="regular bordered full"
                id="phone"
                v-model="newCustomer.phone"
                required
              />
            </div>
            <div class="input-item">
              <label for="phone-type">{{
                $t("create_infoauto_customer_modal.phone_type")
              }}</label>
              <select
                class="regular bordered full"
                id="phone-type"
                v-model.number="newCustomer.phoneType"
              >
                <option
                  v-for="phoneType in phoneTypes"
                  :key="phoneType.value"
                  :value="phoneType.value"
                  >{{ phoneType.label }}</option
                >
              </select>
            </div>
            <div class="input-item">
              <label for="phone">{{
                $t("create_infoauto_customer_modal.rif_cedula")
              }}</label>
              <input
                type="phone"
                class="regular bordered full"
                id="phone"
                v-model="newCustomer.ri"
              />
            </div>
            <template v-if="isCostaRicaStore">
              <div class="input-item">
                <label for="document-type">{{
                  $t("create_infoauto_customer_modal.document_type")
                }}</label>
                <select
                  class="regular bordered full"
                  id="document-type"
                  v-model="newCustomer.tipoDocumento"
                >
                  <option value="">{{
                    $t("create_infoauto_customer_modal.select_document_type")
                  }}</option>
                  <option
                    v-for="documentType in documentTypes"
                    :key="documentType.value"
                    :value="documentType.value"
                    >{{ documentType.label }}</option
                  >
                </select>
              </div>
              <div class="input-item">
                <label for="activity-code">{{
                  $t("create_infoauto_customer_modal.activity_code")
                }}</label>
                <input
                  type="text"
                  class="regular bordered full"
                  id="activity-code"
                  v-model.trim="newCustomer.codActividad"
                />
              </div>
            </template>
            <div class="input-item">
              <label for="sellerId">{{ $t("orders_page.seller") }}</label>
              <select
                required
                v-model="newCustomer.seller"
                name="sellerId"
                class="regular full bordered"
              >
                <option value="">{{
                  $t("create_infoauto_customer_modal.select_seller")
                }}</option>
                <option
                  v-for="seller in sellers"
                  :key="seller.id"
                  :value="seller.id"
                  >{{ seller.name }}
                </option>
              </select>
            </div>
            <div class="input-item">
              <label for="grupo-precio">{{ $t("order.price_level") }}</label>
              <select
                required
                v-model="newCustomer.priceLevelId"
                name="grupo-precio"
                class="regular full bordered"
              >
                <option value="">{{
                  $t("create_infoauto_customer_modal.select_price_level")
                }}</option>
                <option
                  v-for="level in filteredPriceLevels"
                  :key="level.grupoPrecioId"
                  :value="level.grupoPrecioId"
                  >{{ level.descripcion }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <hr class="my-4" />
        <div
          class="input-item flex justify-center items-center mt-4 flex flex-col"
        >
          <div
            v-if="errors"
            class="p-6 bg-red-400 w-full rounded-md text-center text-white mb-4"
          >
            {{ errors }}
          </div>
          <button
            type="submit"
            class="btn-success-button w-40 flex flex-row justify-center"
          >
            <template v-if="!loading">
              {{ $t("address_form.create") }}
            </template>
            <BaseMiniSpinner v-else />
          </button>
        </div>
      </form>
    </div>
  </BaseModal>
</template>
<script>
import { infoautoCreateCustomer } from "@/api/store/Infoauto.js";
import {
  PHONE_TYPES,
  DEFAULT_PHONE_TYPE,
  DOCUMENT_TYPES,
  AREA_CODE_MAX_LENGTH,
  defaultAreaCode
} from "@/constants/infoautoPersona";
const states = require("@/constants/states.json");

export default {
  name: "InfoautoCreateCustomerModal",
  data() {
    return {
      newCustomer: {
        name: "",
        surname: "",
        companyName: "",
        email: "",
        areaCode: defaultAreaCode(
          this.$store.getters["general/getActiveStore"]?.code
        ),
        phone: "",
        phoneType: DEFAULT_PHONE_TYPE,
        postalCode: "",
        type: "",
        modalidadVtaId: "",
        seller: "",
        priceLevelId: "",
        tipoDocumento: "",
        codActividad: "",
        dropship: false
      },
      // User's own seller, found on mount
      defaultSeller: "",
      phoneTypes: PHONE_TYPES,
      areaCodeMaxLength: AREA_CODE_MAX_LENGTH,
      documentTypes: DOCUMENT_TYPES,
      loading: false,
      errors: null
    };
  },
  computed: {
    isCostaRicaStore() {
      const activeStore = this.$store.getters["general/getActiveStore"];
      return activeStore?.code === "nkr_costa_rica";
    },
    modalidadesVenta() {
      return this.$store.getters["general/getModalidadesVenta"];
    },
    // Department's default sale mode (infoauto_modalidad_venta.default; the
    // list comes already filtered by the active department)
    defaultModalidadVtaId() {
      const modalidad = this.modalidadesVenta.find(
        m => Number(m.default) === 1
      );
      return modalidad?.modalidadVtaId || "";
    },
    sellers() {
      return this.$store.getters["general/getSellers"];
    },
    filteredPriceLevels() {
      const allLevels = this.$store.getters["general/getPriceLevels"];
      const currentUser = this.$store.getters["auth/currentUser"];
      const activeStore = this.$store.getters["general/getActiveStore"];

      if (!currentUser || !activeStore?.code) {
        // console.log("Missing user or activeStore", { currentUser, activeStore });
        return [];
      }

      // Permissions are stored by store code in the user profile
      const permissions =
        currentUser.storePriceLevels || currentUser.store_price_levels || {};
      const storeCode = activeStore.code;

      // Try to find permissions using multiple potential key formats
      const camelStoreCode = storeCode.replace(/_([a-z])/g, g =>
        g[1].toUpperCase()
      );
      const altCamelStoreCode =
        storeCode.charAt(0).toLowerCase() + camelStoreCode.slice(1);

      const allowedPairs =
        permissions[storeCode] ||
        permissions[camelStoreCode] ||
        permissions[altCamelStoreCode] ||
        [];

      console.log("DEBUG: Price Level Filtering", {
        storeCode,
        camelStoreCode,
        permissions,
        currentUser,
        allowedPairs,
        allLevelsCount: allLevels.length
      });

      if (!Array.isArray(allowedPairs) || allowedPairs.length === 0) {
        console.warn("No allowed pairs found for store:", storeCode);
        return [];
      }

      return allLevels.filter(level => {
        // Check both camel and snake case for IDs to be extremely safe
        const dId = level.departamentoId || level.departamento_id;
        const gId = level.grupoPrecioId || level.grupo_precio_id;
        const pair = `${dId}:${gId}`;

        const isSelected = allowedPairs.includes(pair);
        // console.log(`Price Level ${level.descripcion} (${pair}): ${isSelected ? 'ALLOWED' : 'DENIED'}`);
        return isSelected;
      });
    },
    statesFixed() {
      const keys = Object.keys(states);
      return keys.map(key => {
        return {
          shortCode: key,
          label: states[key]
        };
      });
    }
  },
  mounted() {
    const currentUser = this.$store.getters["auth/currentUser"];
    const infoautoSeller = this.sellers.find(
      seller => seller.email == currentUser.email
    );
    this.newCustomer.seller = infoautoSeller?.vendedorId || "";
    this.defaultSeller = this.newCustomer.seller;
  },
  watch: {
    "newCustomer.dropship"(dropship) {
      if (dropship && !this.newCustomer.modalidadVtaId) {
        this.newCustomer.modalidadVtaId = this.defaultModalidadVtaId;
      }
    }
  },
  methods: {
    createCustomer() {
      this.errors = null;
      this.loading = true;
      infoautoCreateCustomer(this.newCustomer)
        .then(res => {
          this.$emit("newCustomer", res.customer);
          this.$toast.open({
            message: `${res.message}`,
            type: "success",
            position: "top-center"
          });
          this.$emit("close");
        })
        .catch(err => {
          this.errors = `${err.response?.data?.error ??
            err.response.data.message}`;
          this.$toast.open({
            message: `${err.response?.data?.error ??
              err.response.data.message}`,
            type: "error",
            position: "top-center"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="postcss">
#create-customer-infoauto .modal-content {
  max-width: 600px;
  height: auto;
}
</style>
